import * as React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import CheckBoxItem from './CheckBoxItem';
import ActionTracker from '../utils/ActionTracker';
import { Colors, Fonts } from '../utils/Constants';
const ActionTrack = new ActionTracker();

export default class DropDownItem extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
        hovering: false,
        clicked: false,
    }
  }

  clickedButton = () => {
      this.setState({
        clicked: !this.state.clicked
      })
  }

  hoverButton = () => {
    if(this.state.clicked == false){
      this.setState({
        hovering: !this.state.hovering
      })
    }
  }
  render(){

    let colors = {
      defaultBgColor: this.props.defaultBgColor ? this.props.defaultBgColor : 'white',
      highlightedBgColor: this.props.highlightedBgColor ? this.props.highlightedBgColor : '#33789B',
      defaultTextColor: this.props.defaultTextColor ? this.props.defaultTextColor : '#4A4A4A',
      highlightedTextColor: this.props.highlightedTextColor ? this.props.highlightedTextColor : 'white'
    }

    var properties = {
      image: require('../assets/images/dropdownarrow_black.svg'),
      color: colors.defaultBgColor,
      textColor: colors.defaultTextColor
    };
    return (
      <View style={{width: this.props.width}}>
        <TouchableOpacity style={{width: this.props.width, height: this.props.height, marginBottom: 16}} onPress={() => this.clickedButton()} onMouseEnter={() => this.hoverButton()} onMouseLeave={() => this.hoverButton()}>
          <View style = {[styles.button, {width: '100%', height: '100%', backgroundColor: properties.color}]}>
            <View style={{flex: 8, paddingRight: 10}}>
                <Text style={[styles.campaigntitle, {color: properties.textColor}]}>{this.props.title}</Text>
                <Text style={[styles.description, {color: properties.textColor}]}>{this.props.text}</Text>
            </View>
            <Image
                style={{width: 34.62, height: 19.16, resizeMode: 'contain', justifyContent: 'flex-end', flex: 0.75, transform: [{ rotate: this.state.clicked ? '180deg':'0deg'}]}}
                source={properties.image}
            />
          </View>
        </TouchableOpacity>
        <View style={{alignItems: 'center',  width: '100%'}}>
          {
          this.state.clicked &&
            this.props.content.map((item, index) => (
                <CheckBoxItem
                  key={index}
                  item={item}
                  width = {'90%'}
                  defaultBgColor={'white'}
                  height = {this.props.height}
                  borderWidth = {1}
                  actionCompleted = {this.props.actionCompleted(item.name, this.props.actionType)}
                  checkOffAction = {() => this.props.checkOffAction({'name': item.name,'type': this.props.actionType})}
                />
            ))
          }
        </View>
      </View>
    );
  }
}

DropDownItem.navigationOptions = {
  header: null,
};

const styles = StyleSheet.create({
  button: {
    padding: 27,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 0,
    //   height: 2.54,
    // },
    // shadowOpacity: 0.1,
    // shadowRadius: 15,
    borderColor: 'black',
    borderWidth: 1
  },
  campaigntitle: {
    fontSize: 19,
    fontFamily: Fonts.mainFont,
    fontWeight: 'bold'
  },
  description: {
    paddingTop: 6,
    fontFamily: Fonts.mainFont,
    fontSize: 13,
    fontWeight: 'normal'
  }
});